export default "__VITE_ASSET__d4G0KwSv__"